export default {
    name: "Base",
    __LayoutComponent__: true,
    props: {
        /**
         * @type {object}
         * @description 网格系统配置
         */
        config: {
            type: Object,
            default: () => ({})
        },
        /** 
         * @type {Object}
         * @description 布局配置
         */
        layoutConfig: {
            type: Object,
            required: true
        }
    },
    computed: {
        LayoutMan() {
            return this.config.LayoutMan;
        }
    },
    watch: {
        layoutConfig: {
            handler() {
                this.layoutConfig.VueComponent = this;
            },
            immediate: true
        }
    },
    methods: {
        GetGridLayoutStyle() {
            const _positionInfo = this.layoutConfig.GetPositionInfo();
            return {
                gridRowStart: _positionInfo.Row,
                gridRowEnd: _positionInfo.Row + _positionInfo.Rows,
                gridColumnStart: _positionInfo.Column,
                gridColumnEnd: _positionInfo.Column + _positionInfo.Columns
            };
        }
    }
};